import style from './Plans/Plan.module.scss';
import React from 'react';
import { preparePriceBlock } from './Price';

export const getCostBlock = ({yearly, monthAmount, prevMonthAmount, yearAmount, prevYearAmount, showAnnuallyPrice = true}: {
  yearly?: boolean;
  monthAmount?: number;
  prevMonthAmount?: number;
  yearAmount?: number;
  prevYearAmount?: number;
  showAnnuallyPrice?: boolean;
} = {}) => {
  return <div className={style.cost}>
    <div className={style.price}>{preparePriceBlock({
      amount: yearly ? yearAmount && (yearAmount / 12) : monthAmount,
      prevAmount: yearly ? prevYearAmount && (prevYearAmount / 12) : prevMonthAmount
    })}</div>
    <sub>/mo</sub>
    {yearly && monthAmount ? <s className={style.price}>{preparePriceBlock({
      amount: monthAmount,
      prevAmount: prevMonthAmount
    })}</s> : ''}
    {!yearly
      ? monthAmount ? <div className={style.payment_period}>billed <strong>monthly</strong></div> : ''
      : yearAmount ? <div className={style.payment_period}>billed <strong>annually</strong>{showAnnuallyPrice ? <>,
        ${yearAmount / 100}</> : ''}</div> : ''
    }
  </div>
}
